export const getColumns = () => {
  return [
    {
      'Header': 'CÓDIGO',
      'accessor': 'code',
      'width': 4,
    },
    {
      'Header': 'FRANQUICIA',
      'accessor': 'franchise',
      'width': 2,
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'name',
      'width': 8,
    },
  ];
};
